import { db, type OfflineAttachment } from './db';

export class OfflineAttachmentRepository {
  async add(data: Omit<OfflineAttachment, 'id' | 'createdAt' | 'updatedAt' | 'uploaded'>): Promise<string> {
    const id = crypto.randomUUID();
    const now = Date.now();

    const attachment: OfflineAttachment = {
      ...data,
      uploaded: false,
      id,
      createdAt: now,
      updatedAt: now
    };

    await db.offlineAttachments.add(attachment);
    return id;
  }

  async getById(id: string): Promise<OfflineAttachment | undefined> {
    return db.offlineAttachments.get(id);
  }

  async getByMaintenanceId(maintenanceId: string): Promise<OfflineAttachment[]> {
    return db.offlineAttachments.where('maintenanceId').equals(maintenanceId).toArray();
  }

  async getPendingUploads(): Promise<OfflineAttachment[]> {
    return db.offlineAttachments.where('uploaded').equals(0).toArray();
  }

  async getPendingUploadsByMaintenanceId(maintenanceId: string): Promise<OfflineAttachment[]> {
    return db.offlineAttachments.where({ maintenanceId, uploaded: false }).toArray();
  }

  async markAsUploaded(id: string, uploadedUrl: string): Promise<void> {
    await db.offlineAttachments.update(id, {
      uploaded: true,
      uploadedUrl,
      updatedAt: Date.now()
    });
  }
  async remove(id: string): Promise<void> {
    await db.offlineAttachments.delete(id);
  }

  async removeByMaintenanceId(maintenanceId: string): Promise<void> {
    const attachments = await this.getByMaintenanceId(maintenanceId);
    await db.offlineAttachments.bulkDelete(attachments.map((item) => item.id));
  }

  async clearUploaded(): Promise<void> {
    const uploaded = await db.offlineAttachments.where('uploaded').equals(1).toArray();

    await db.offlineAttachments.bulkDelete(uploaded.map((item) => item.id));
  }
}

export const offlineAttachmentRepository = new OfflineAttachmentRepository();
